import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { QcLedger } from 'entities/qc_ledger'
import { ReactNode, useMemo } from 'react'
import { Form } from 'utils/hooks'
import { toDateText } from 'utils/util'

export const qcLedgerColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, width: 50, form: form, orderAttr: 'qc_ledger_id', searchType: { name: 'id', type: 'multiple_text' }, align: 'center' },
            { name: '報告者', th: true, minWidth: 50 },
            {
                name: '作成日',
                th: true,
                width: 120,
                form: form,
                align: 'center',
                orderAttr: 'qc_ledger_create_date',
                searchType: { name: 'create_date', type: 'multiple_text' },
            },
            {
                name: '指導医報告日',
                th: true,
                width: 120,
                form: form,
                align: 'center',
                orderAttr: 'qc_ledger_reporting_date',
                searchType: { name: 'reporting_date', type: 'multiple_text' },
            },
            {
                name: '異常発生日',
                th: true,
                width: 120,
                form: form,
                orderAttr: 'qc_ledger_start',
                searchType: { name: 'start', type: 'multiple_text' },
                align: 'center',
            },
            {
                name: '異常終了日',
                th: true,
                width: 120,
                form: form,
                orderAttr: 'qc_ledger_end',
                searchType: { name: 'end', type: 'multiple_text' },
                align: 'center',
            },
        ],
    }
}

export type QcLedgerTableDataProps = {
    qcLedger?: QcLedger
    displaySetting: DisplaySetting
}

export const QcLedgerTableData = ({ qcLedger, displaySetting }: QcLedgerTableDataProps): JSX.Element => {
    if (!qcLedger) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        return (
            <>
                <TableCell align="center">{qcLedger.id}</TableCell>
                <TableCell>{qcLedger.user?.fullName}</TableCell>
                <TableCell align="center">{toDateText(qcLedger.createDate)}</TableCell>
                <TableCell align="center">{toDateText(qcLedger.reportingDate)}</TableCell>
                <TableCell align="center">{toDateText(qcLedger.start)}</TableCell>
                <TableCell align="center">{toDateText(qcLedger.end)}</TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
